module.exports = __webpack_public_path__ + "static/media/saqvojazhProduct.8482a4f9.jpeg";